import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames";
import sift from "sift";
import config from "../../config";
import styles from "./Advertising.module.scss";

var ads = config.promotions,
    otherAds = ads.filter(sift({
  match: {
    $elemMatch: {
      type: {
        $nin: ["neighbourhood", "release"]
      }
    }
  }
})),
    releaseAds = ads.filter(sift({
  match: {
    $elemMatch: {
      type: "release"
    }
  }
})),
    neighbourhoodsAds = ads.filter(sift({
  match: {
    $elemMatch: {
      type: "neighbourhood"
    }
  }
})),
    filterAds = function filterAds(a, b, c) {
  var d = c ? "release" === c ? releaseAds : "neighbourhood" === c ? neighbourhoodsAds : null : otherAds,
      e = a.filter(sift({
    type: c ? c : {
      $nin: ["neighbourhood", "release"]
    }
  })),
      f = e ? {
    match: {
      $elemMatch: {
        $or: e
      }
    }
  } : null,
      g = f ? b ? d.filter(sift(f))[b] : d.find(sift(f)) : null;
  return g || "neighbourhood" === c ? g : g || c ? g || "release" !== c ? void 0 : filterAds(a, b, "neighbourhood") : filterAds(a, b, "release");
};

export var Advertising = function Advertising(a) {
  var b = a.className,
      c = a.query,
      d = a.index,
      e = a.height,
      f = _objectWithoutProperties(a, ["className", "query", "index", "height"]),
      g = c ? filterAds(c, d) : null;

  if (!g) return null;
  var h = g.get("image.desktop") || g.get("image"),
      i = g.get("image.mobile") || g.get("image"),
      j = g.get("link");
  return h && j ? /*#__PURE__*/React.createElement("a", Object.assign({}, f, {
    className: classnames(styles.promo, b),
    href: j,
    target: "_BLANK",
    rel: "noopener noreferrer"
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(_defineProperty({}, styles.desktop, i)),
    style: {
      backgroundImage: "url(".concat(h, ")"),
      height: e
    }
  }), i ? /*#__PURE__*/React.createElement("div", {
    className: styles.mobile,
    style: {
      backgroundImage: "url(".concat(i, ")"),
      height: e
    }
  }) : null) : null;
};
export default Advertising;